'use strict';

var titles = {};

exports.__exports = titles;
//# sourceMappingURL=titles.cjs.map
